import React from 'react';
import TextComponent from '/components/forms-v2/Text.component';

const ChapterSelect = ({ control }) => {
  return <TextComponent name='chapter' control={control} label='Chapter' disabled />;
};

export default ChapterSelect;
